module.exports = __webpack_public_path__ + "media/img/logos/2024/jobboerse-stellenangebote-berufseinsteiger-ostern-38e974ddf774287f4910b24845074746.svg";